/**
 * Created by mykurisu on 2017/12/22.
 */
import React from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {renderNewMoney, GetRealLength, isLZWKAPP} from '../../../utils'
import axios from 'axios'
import SharecardSaleIcon from '../../../images/activity/giftcard/money.png'
import Close from '../../../images/activity/couponspa/main__close.png'
import None from '../../../images/activity/giftcard/none.png'
import headerImg from '../../../images/activity/giftcard/header.png'
import '../../../css/page/GiftCard.css'


class SelectItem extends React.Component {
    render() {
        return (
            <div
                className={this.props.content.template_id === this.props.selectedId ? 'select__item select__item-active' : 'select__item'}
                style={{backgroundImage: `url(${this.props.content.avatar})`}}
                onClick={() => this.props.handleSelectedImage(this.props.content.template_id, this.props.content.avatar, this.props.content.avatar2,  this.props.content.description)}
            >

            </div>
        )
    }
}


class FixedList extends React.Component {

    constructor() {
        super();
        this.state = {
            freeze_fee: 0,
            total_fee: 0,
            records: []
        }
    }

    componentDidMount() {
        axios.get('/api/wallet/rebate_record')
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        records: res.data.data.records,
                        freeze_fee: res.data.data.freeze_fee,
                        total_fee: res.data.data.total_fee,
                    })
                }
            })
    }

    render() {
        return (
            <div className="fixed__list">
                <div className="list__mask" onClick={() => this.props.handleCloseWallet()}></div>
                {this.state.records.length !== 0 ?
                    <div className="list__container-has">
                        <div className="container__top">
                            <div className="top__price">
                                <div className="price__item">
                                    <p>累计奖励</p>
                                    <p>￥<span>{renderNewMoney(this.state.total_fee)[0]}</span></p>
                                </div>
                                <div className="price__item-r">
                                    <p>冻结中</p>
                                    <p>￥<span>{renderNewMoney(this.state.freeze_fee)[0]}</span></p>
                                </div>
                            </div>
                            <div className="top__btn" onClick={() => location.assign('/wallet')}>
                                提现
                            </div>
                            {/* <div className="top__intro">
                                提示：奖励有7天冻结期，若朋友在此期间退款，奖金无效。冻结期过后，奖励即可提现！
                            </div> */}
                        </div>
                        <div className="container__bottom">
                            {this.state.records.map((item) => {
                                return (
                                    <div className="bottom__item" key={item.freeze.invoice_id}>
                                        <div className="item__l">
                                            <div className="l__icon" style={{backgroundImage: `url(${item.payer.avatar_url})`}}>

                                            </div>
                                            <div className="l__name">
                                                <p>{item.payer.nickname}</p>
                                                <p>使用了红包</p>
                                                <p>{item.tran.create_time}</p>
                                            </div>
                                        </div>
                                        <div className="item__r">
                                            <p style={{color: (item.freeze.status === 'freezed' && item.freeze.expired_timestamp < Date.now()/1000) ? '#FF3F3C' : 'inhert'}}>￥{renderNewMoney(item.tran.change)[0]}</p>
                                            <p>奖励</p>
                                            <p>{(item.freeze.status === 'freezed' && item.freeze.expired_timestamp > Date.now()/1000) && '冻结中'}</p>
                                            <p>{(item.freeze.status === 'freezed' && item.freeze.expired_timestamp < Date.now()/1000) && ''}</p>
                                            <p>{item.freeze.status === 'unfreezed' && '失效'}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    :
                    <div className="list__container-none">
                        <div className="container__top">
                            <div className="top__price">
                                <div className="price__item-r">
                                    <p>累计奖励</p>
                                    <p>￥<span>0</span></p>
                                </div>
                                <div className="price__item-r">
                                    <p>冻结中</p>
                                    <p>￥<span>0</span></p>
                                </div>
                            </div>
                            <div className="top__btn">
                                提现
                            </div>
                        </div>
                        <div className="container__bottom">
                            <img src={None} alt=""/>
                            <p>你还没有奖励哦，<br />快去生成心意卡发送给好友吧</p>
                        </div>
                    </div>
                }
                <div className="list__close" onClick={() => this.props.handleCloseWallet()}>
                    <img src={Close} alt=""/>
                </div>
            </div>
        )
    }
}


class GiftCard extends React.Component {

    constructor(props) {
        super();
        this.state = {
            cardList: [],
            selectedId: 0,
            selectedUrl: '',
            selectedBigUrl: '',
            textValue: '',
            textValueNum: 40,
            description: '',
            walletShow: false,

            //query from
            from: props.location.query.k_from || 'unknow'
        }
    }

    componentDidMount() {
        document.title = '送心意，赚奖励';
        const bagid = this.props.location.query.bagid;
        const autoalert = this.props.location.query.autoalert;
        axios.get(`/api/coupon/weike_active/${bagid}/info`)
            .then(res => {
                if (res.data.code === 0){
                    let data = res.data.data;
                    this.props.dispatch({
                        type: 'UPDATE_SHARE_DATA',
                        payload: {
                            title: data.share_info.share_title,
                            desc: data.share_info.share_description,
                            imgUrl: data.share_info.share_icon,
                            type: 'link',
                            link: data.share_info.share_url,
                            is_resell: '1'
                        }
                    });
                }
            });

        axios.get(`api/coupon/sharecard/all_theme?from=${this.state.from}`).then(res => {
            if (res.data.code === 0) {
                this.setState({
                    cardList: res.data.data.template_list,
                    selectedId: res.data.data.template_list[0].template_id,
                    selectedUrl: res.data.data.template_list[0].avatar,
                    selectedBigUrl: res.data.data.template_list[0].avatar2,
                    description: res.data.data.template_list[0].description
                })
            }
        });

        if (autoalert){
            this.setState({
                walletShow: true
            })
        }
    }

    handleSelectedImage(id, url, url2, description) {
        this.setState({
            selectedId: id,
            selectedUrl: url,
            selectedBigUrl: url2,
            description: description
        })
    }

    handelInput(e) {
        // this.setState({
        //     textValue: e.target.value
        // }, () => {
        //     if ((40 - this.state.textValue.length) < 0) {
        //         let text = this.state.textValue;
        //         this.setState({
        //             textValue: text.slice(0, 40),
        //             textValueNum: 0
        //         })
        //     } else {
        //         this.setState({
        //             textValueNum: 40 - this.state.textValue.length
        //         })
        //     }
        // })

        if (Math.round(GetRealLength(e.target.value) / 2) > 40){
            return
        }

        this.setState({
            textValue: e.target.value
        }, () => {
            this.setState({
                textValueNum: 40 - Math.round(GetRealLength(this.state.textValue) / 2)
            })
        })
    }

    handleCloseWallet() {
        this.setState({
            walletShow: false
        })
    }

    render() {
        const {query} = this.props.location;
        let share_url = `/specials/giftcard/detail?bagid=${query.bagid}&template_id=${this.state.selectedId}&greettext=${encodeURIComponent(this.state.textValue)}&from=${this.state.from}`;
        if (this.state.textValue === '') {
            share_url = `/specials/giftcard/detail?bagid=${query.bagid}&template_id=${this.state.selectedId}&greettext=${encodeURIComponent(this.state.description)}&from=${this.state.from}`;
        }

        return (
            <div className="giftcard__container">
                {this.state.walletShow &&
                <FixedList handleCloseWallet={() => this.handleCloseWallet()}/>
                }

                <div className="container__wallet-entry" onClick={() => this.setState({walletShow: true})}>
                    <span className="sharecard-slide-page-tips_icon">
                        <img src={SharecardSaleIcon} alt=""/>
                    </span>
                    <span>
                        我的奖励
                    </span>
                </div>

                <div className="container__header">
                    <img src={headerImg} alt=""/>
                </div>

                <div className="container__banner">
                    <img src={this.state.selectedBigUrl} alt=""/>
                </div>

                <div className="container__title">
                    选择心意卡片
                </div>
                <div className="container__selector">
                    <div className="selector__wrap"
                         style={{width: `calc(130px * ${this.state.cardList.length} - 10px)`}}>
                        {this.state.cardList.map((item) => <SelectItem
                            key={item.template_id}
                            content={item}
                            selectedId={this.state.selectedId}
                            handleSelectedImage={(id, url, url2, description) => this.handleSelectedImage(id, url, url2, description)}
                        />)}
                    </div>
                </div>

                <div className="container__title">
                    填写祝福语
                </div>
                <div className="container__inputarea">
                    <textarea rows="3"
                              placeholder={this.state.description}
                              value={this.state.textValue}
                              onChange={(e) => this.handelInput(e)}
                    ></textarea>
                    <div className="inputarea__num">
                        {this.state.textValueNum}
                    </div>
                </div>

                <div className="container__intro">
                    <div className='container__title'>送心意领现金</div>
                    1. 免费生成红包送给朋友<br/>
                    2. 红包为课程优惠券<br/>
                    3. 朋友使用红包后，{isLZWKAPP() ? '你将获得3元现金奖励' : '你将获得现金奖励'}<br/>
                </div>

                <div className="container__btn"
                     onClick={() => window.location = share_url}>
                    {isLZWKAPP() ? '赠送好友 领3元现金' : '我要赠送'}
                </div>
            </div>
        )
    }
}

export default connect(state => ({

}))(GiftCard)



// WEBPACK FOOTER //
// ./src/pages/ActivityPage/GiftCard/GiftCard.js